import { BodyParts, InjuryTypes } from 'components/InjuryV2/bodyPartInjuryMapping'
import { FilterDate, Gender } from 'services'
import { Seasons } from 'store/ducks'
import alpha3List from '../../../assets/locales/alpha3.nationalities.json'

type Translation = (x: string) => string

export const gender = (t: Translation) => [
  {
    label: t('all'),
    value: Gender.ALL
  },
  {
    label: t('male'),
    value: Gender.MALE
  },
  {
    label: t('female'),
    value: Gender.FEMALE
  }
]

export const bodyParts = (t: Translation) => [
  { label: t('head'), value: BodyParts.HEAD },
  { label: t('face'), value: BodyParts.FACE },
  { label: t('throat'), value: BodyParts.THROAT },
  { label: t('neck'), value: BodyParts.NECK },
  { label: t('collarbone'), value: BodyParts.COLLARBONE },
  { label: t('shoulder'), value: BodyParts.SHOULDER },
  { label: t('arm'), value: BodyParts.UPPER_ARM },
  { label: t('wrist'), value: BodyParts.WRIST },
  { label: t('hand'), value: BodyParts.HAND },
  { label: t('finger'), value: BodyParts.THUMB },
  { label: t('breast'), value: BodyParts.BREAST },
  { label: t('stomach'), value: BodyParts.ABDOMEN },
  { label: t('back'), value: BodyParts.BACK },
  { label: t('buttock'), value: BodyParts.BUTTOCKS },
  { label: t('hip'), value: BodyParts.HIP },
  { label: t('pelvis'), value: BodyParts.PELVIS },
  { label: t('genitalia'), value: BodyParts.GENITALIA },
  { label: t('thigh'), value: BodyParts.THIGH },
  { label: t('knee'), value: BodyParts.KNEE },
  { label: t('calf'), value: BodyParts.LOWER_LEG },
  { label: t('ankleFoot'), value: BodyParts.FOOT_ANKLE }
]

export const injuryTypes = (t: Translation) => [
  { label: t('fracture'), value: InjuryTypes.FRACTURE },
  { label: t('dislocated'), value: InjuryTypes.DISLOCATED },
  { label: t('sprain'), value: InjuryTypes.SPRAIN },
  { label: t('impactShock'), value: InjuryTypes.IMPACT_SHOCK },
  { label: t('cutsWounds'), value: InjuryTypes.CUTS_WOUNDS },
  { label: t('concussion'), value: InjuryTypes.CONCUSSION },
  { label: t('acuteSickness'), value: InjuryTypes.ACUTE_SICKNESS },
  { label: t('dead'), value: InjuryTypes.DEAD }
]

export const age = [
  {
    label: '1 - 100',
    value: '1,100'
  },
  {
    label: '1 - 10',
    value: '1,10'
  },
  {
    label: '11 - 20',
    value: '11,20'
  },
  {
    label: '21 - 30',
    value: '21,30'
  },
  {
    label: '31 - 40',
    value: '31,40'
  },
  {
    label: '41 - 50',
    value: '41,50'
  },
  {
    label: '51 - 60',
    value: '51,60'
  },
  {
    label: '61 - 70',
    value: '61,70'
  },
  {
    label: '71 - 80',
    value: '71,80'
  },
  {
    label: '81 - 90',
    value: '81,90'
  },
  {
    label: '91 - 100',
    value: '91,100'
  }
]

export const seasons = (t: Translation) => [
  {
    label: t('winter'),
    value: Seasons.WINTER
  },
  {
    label: t('summer'),
    value: Seasons.SUMMER
  }
]

export const nationalities = (t: Translation) => {
  const all = { label: '', id: '' }
  const nationalities = alpha3List.map(item => ({
    label: t(item),
    id: item
  }))

  return [{ ...all }, ...nationalities]
}

export const dates = (t: Translation) => [
  // {
  //   label: t('today'),
  //   value: FilterDate.TODAY
  // },
  // {
  //   label: t('thisWeek'),
  //   value: FilterDate.THIS_WEEK
  // },
  // {
  //   label: t('thisMonth'),
  //   value: FilterDate.THIS_MONTH
  // },
  {
    label: t('thisYear'),
    value: FilterDate.THIS_YEAR
  },
  {
    label: '2022',
    value: 2022
  }
]
